import React from "react";
import PageWrapper from "../../components/UI/PageWrapper";
import ProfileSectionedArtistProfile from "../../components/Profile/ProfileSectionedArtistProfile";

const ProfileChangePasswordPage: React.FC = () => {
  return (
    <PageWrapper>
      <ProfileSectionedArtistProfile activeSection="password" />
    </PageWrapper>
  );
};

export default ProfileChangePasswordPage;

